import React from 'react';

import type { AuthorEntity } from '@schibsted/frapi-schema';

import { LinkWithPulse } from '../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import { stripTrailingNumbers } from '../../authorBio/helpers.js';
import { getImageUrl } from '../../commonComponents/imageUtils.js';

interface AdditionalProps {
  showCircle: boolean;
  section: string;
}
const Author: React.FC<AuthorEntity & AdditionalProps> = ({
  slug,
  contacts,
  title,
  enabled: bioPageEnabled,
  imageAsset,
  showCircle,
  section,
}) =>
  bioPageEnabled ? (
    <LinkWithPulse
      className="author"
      href={`/vink-redaksjonen/${stripTrailingNumbers(slug || '')}`}
      objectId={`article:byline`}
      name="redirect to bio page for author"
      ariaLabel="Les mer om forfatteren"
      rel="author"
    >
      <Info
        contacts={contacts}
        title={title}
        imageAsset={imageAsset}
        section={section}
      />
      {showCircle && <div className="circle"></div>}
    </LinkWithPulse>
  ) : (
    <div className="author">
      <Info
        contacts={contacts}
        title={title}
        imageAsset={imageAsset}
        section={section}
      />
    </div>
  );

const Info: React.FC<
  Pick<AuthorEntity, 'contacts' | 'title' | 'imageAsset'> &
    Pick<AdditionalProps, 'section'>
> = ({ contacts, title, imageAsset, section }) => {
  const workTitle = contacts.find((c) => c.type === 'title')?.value;
  const imageUrl = imageAsset ? getImageUrl(imageAsset.id, 480, 540) : null;

  return (
    <>
      <div
        className={`author-info ${imageUrl ? '' : 'without-image'} ${section}`}
      >
        {imageUrl && (
          <div className="image-frame">
            <img src={imageUrl} alt={imageAsset?.id} />
          </div>
        )}
        <div className="author-bio-wrapper">
          {title && <p className="author-name">{title}</p>}
          {workTitle && <p className="author-work-title">{workTitle}</p>}
        </div>
      </div>
    </>
  );
};

export default Author;
